import * as React from "react";
import type { SVGProps } from "react";
const SvgHomeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="home_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M704 640H320v85.333h384V640zM559.787 83.541a85.333 85.333 0 0 0-96.683.043L100.907 332.885A85.333 85.333 0 0 0 64 403.2v466.901a85.333 85.333 0 0 0 85.333 85.334h725.419a85.333 85.333 0 0 0 85.333-85.334V403.2a85.333 85.333 0 0 0-37.034-70.315L559.787 83.541zM511.488 153.9l363.221 249.3v466.901H149.333V403.2l362.24-249.301z"
    />
  </svg>
);
export default SvgHomeIcon;
